import { render, staticRenderFns } from "./Sent.vue?vue&type=template&id=5c7ec094&"
import script from "./Sent.vue?vue&type=script&lang=js&"
export * from "./Sent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports